import {h, Fragment} from "preact"
export default function Sizes({ relatedProducts, currentProduct }) {

    return(
        <>
            {relatedProducts?.map((product, index) => {
                if(index < 5 && product.productId != currentProduct){
                    return(
                    <ul class={`coll-product-swatch sizes-${product.productId} ns-d-none`}>
                        {product.skus?.map((sku) => {
                            const size = sku?.attributes?.find(field => field.key.toLowerCase() == "size")?.value;
                            return (
                                <li class={`swatch-element ${sku.availability == "InStock" ? 'available' : 'soldout'}`}>
                                    <input
                                    type="radio"
                                    id={`${product.productId}-${sku.id}`}
                                    data-product-id={product.productId}
                                    data-var-id={sku.id}
                                    name="Size"
                                    value={size}
                                    data-main-price={sku.price}
                                    data-compare-price={sku.price}
                                    />
                                    <label for={`${product.productId}-${sku.id}`}>{size}</label>
                                </li>
                            )          
                        })}
                    </ul>
                )}
            })}
        </>
    )

}